import {
  detect,
  BrowserInfo,
  BotInfo,
  NodeInfo,
  ReactNativeInfo,
  SearchBotDeviceInfo,
  Browser,
} from 'detect-browser';
import { Logging } from '../..';

export interface BrowsingInfo {
  type?: 'browser' | 'bot' | 'bot-device' | 'node' | 'react-native';
  name?: string;
  os?: string;
  version?: string;
  bot?: string | boolean;
}

export function getBrowsingInfo(): BrowsingInfo {
  const result = detect();
  const info: BrowsingInfo = {};

  if (result) {
    info.type = result.type;
    switch (result.type) {
      case 'browser':
        {
          const browserInfo: BrowserInfo = result as BrowserInfo;
          info.name = browserInfo.name;
          info.version = browserInfo.version;
          info.os = browserInfo.os;
        }
        break;
      case 'bot':
        {
          const botInfo: BotInfo = result as BotInfo;
          info.name = botInfo.name;
          info.version = botInfo.version;
          info.os = botInfo.os;
          info.bot = botInfo.bot;
        }
        break;
      case 'bot-device':
        {
          const botDeviceInfo: SearchBotDeviceInfo = result as SearchBotDeviceInfo;
          info.name = botDeviceInfo.name;
          info.version = botDeviceInfo.version;
          info.os = botDeviceInfo.os;
          info.bot = botDeviceInfo.bot;
        }
        break;
      case 'node':
        {
          const nodeInfo: NodeInfo = result as NodeInfo;
          info.name = nodeInfo.name;
          info.version = nodeInfo.version;
          info.os = nodeInfo.os;
        }
        break;
      case 'react-native':
        {
          const reactNativeInfo: BrowsingInfo = result as ReactNativeInfo;
          info.name = reactNativeInfo.name;
          info.version = reactNativeInfo.version;
          info.os = reactNativeInfo.os;
          info.bot = reactNativeInfo.bot;
        }
        break;
      default:
        break;
    }
  }

  return info;
}

export function isSafari(info?: BrowsingInfo): boolean {
  let browsingInfo: BrowsingInfo = info;

  if (!browsingInfo) {
    browsingInfo = getBrowsingInfo();
  }

  return browsingInfo && (browsingInfo.type === 'browser') && ((browsingInfo.name as Browser) === 'safari');
}

export function isChrome(info?: BrowsingInfo): boolean {
  let browsingInfo: BrowsingInfo = info;

  if (!browsingInfo) {
    browsingInfo = getBrowsingInfo();
  }

  return browsingInfo && (browsingInfo.type === 'browser') && ((browsingInfo.name as Browser) === 'chrome');
}

export function isFirefox(info?: BrowsingInfo): boolean {
  let browsingInfo: BrowsingInfo = info;

  if (!browsingInfo) {
    browsingInfo = getBrowsingInfo();
  }

  return browsingInfo && (browsingInfo.type === 'browser') && ((browsingInfo.name as Browser) === 'firefox');
}

export function isEdge(info?: BrowsingInfo): boolean {
  let browsingInfo: BrowsingInfo = info;

  if (!browsingInfo) {
    browsingInfo = getBrowsingInfo();
  }

  return browsingInfo && (browsingInfo.type === 'browser') && ((browsingInfo.name as Browser) === 'edge');
}
